import { clone, state, ui, res, prefs } from './stores.js';
import { get } from 'svelte/store';
import { choose, currentPlayer, pause, waitMillis } from './ui.js';
import { closeWorkingLog, logText, openWorkingLog, moveTo, getPlayerIndex, getNeutralZone, doAction, checkForReactions, resetCache, isBadlands, allCards } from './game.js';
import { autoCardActions, cacheItem, clearCacheItem, doActionPause, getAllPlayEffects, getCardEffect, getHints, ongoingEffects, ongoingPlayer, otherPlayer, resolveEffects, shipsAtLocation } from './parse.js';
import { allTokenTypes, canBeamTo, cardResourceTypes, countShips, defpCard, drones, hasMurf, matches, myAway, oneOffMessage, removeAwayTeam, removableAway, sdCards, possArray, cardsInPlay } from './card_actions.js';
import { allScoreableCards, getTrackMultiplier } from './scores.js';
import { collectableTraits } from './khan.js';
import { perfMeasureAsync } from './perf.js';

export function convertBotLevel(l){
    return `${l[0].toUpperCase()}${l.slice(1)}`;
    if(l == 'easy'){
        return `Easy (Phasers to Stun)`;
    }else if(l == 'standard'){
        return `Standard (Good Day to Die)`;
    }else if(l == 'hard'){
        return `Hard (Resistance Is Futile)`
    }else if(l == 'Kobayashi Maru'){
        return `Kobayashi Maru (No-Win Scenario)`
    }
}

export function nextBotLevel(current){
    let levels = botLevels()
    let index = levels.indexOf(current);
    if(index == -1) return 0;
    if(index + 1 == levels.length) return -1;
    return levels[index + 1];
}

export function botLevels(){
    return botDifficulties;
}

// Level names only, in order: campaign.js indexes into this list. The stardate rows that
// used to hang off these keys now come from the sheet (mode 'Solo vs <first word> Bot').
let botDifficulties = ['Ensign (level 1)', 'Lieutenant (Level 2)', 'Commander (Level 3)', 'Captain (Level 4)', 'Admiral (Level 5)'];

export function botAvailableText(cap){
    let chart = get(res).botCharts[cap];
    if(!chart) return '';
    let borkedCount = 0;
    for(let row of Object.keys(get(res).parsedCardText).filter(k => k.startsWith(`${cap}_bot`))){
        if(!get(res).parsedCardText[row] || get(res).parsedCardText[row].response == 'error') borkedCount++;
    }
    if(borkedCount){
        return `(bot not ready: ${borkedCount} effects not parsing)`;
    }else{
        return `(bot available)`
    }
}

export function howManyBotActions(p, state){
    //let difficulty = 0; // Later this can be adjusted
    let actions = [3, 3, 3, 4, 4];
    let index = state.stardatePlayed;
    //console.log(get(res), get(state).stardateCards);
    if(index >= sdCards().length) index = sdCards().length - 1;
    let num = sdCards()[index].botActions;
    //if(p.captain == 'Boimler' && p.bot) return num - 1;
    return num;
}

export function botValue(card, player, setup = false){
    let baseValue = 0;
    if(card.vp && parseInt(card.vp)){
        baseValue = card.vp;
    }else if(card.focus_vp){
        if(setup){
            baseValue = 5;
        }else if(player.captain == 'Khan' && player.bot && player.currentChart == 'regular'){
            // worth 3 regardless of track value
            baseValue = 3;
        }else{
            // calculate based on tracks...!
            let mult = getTrackMultiplier(player, card.stripe);
            console.log(`Track multiplier for ${card.stripe}=${mult}`);
            baseValue = mult;
            //return 5; // !! TODO implement properly
        }
    }
    // Endgame scoring too. NB currently for bot and for human.
    // Deliberately not getHints: that applies the *active* player's [[mil6]]-style threshold,
    // so a location's endgame op silently stopped counting whenever the other player was below it.
    if(getCardEffect(card, 'endgame').length > 0) baseValue += 5;
    if(player.bot && player.captain == 'Khan' && player.currentChart == 'regular'){
        if(card.deck != 'Khan' && collectableTraits(card.traits, player).length > 0) baseValue += 3;
    }
    if(card.glory) baseValue += card.glory; // TODO should it?
    //if(player.captain == 'Burnham' && player.bot && card.dilithium) baseValue += card.dilithium;
    // TODO should away teams break ties?
    if(player.bot && player.captain == 'Freeman' && card.traits.includes('lower decker')) baseValue++;
    if(player.bot && player.captain == 'Riker' && matches(card, ['nx-01', 'android', 'pakled', 'lower decker', 'beverage', 'betazoid'])) baseValue++;
    return baseValue;
}

// botValue calls getHints, which trawls every card in play twice. A comparator runs
// it O(n log n) times over the same handful of cards, so price each card once per
// sort instead. Only valid for a single synchronous sort - make a new one each time.
export function botValuer(player, setup = false){
    let cache = new Map();
    return c => {
        if(!cache.has(c)) cache.set(c, botValue(c, player, setup));
        return cache.get(c);
    };
}

export function botFavouriteCards(p, eligible){
    let order = ['person', 'cargo', 'ship', 'ally'];
    let val = botValuer(p);
    eligible = eligible.sort((a,b) =>{
        let aValue = val(a);
        let bValue = val(b);
        console.log(`${a.name} value ${aValue}, ${b.name} value ${bValue}`)
        if(aValue != bValue) return bValue - aValue;
        let aTokens = countAllTokens(a);
        let bTokens = countAllTokens(b);
        console.log(`${a.name} tokens ${aTokens}, ${b.name} tokens ${bTokens}`)
        if(aTokens != bTokens) return bTokens - aTokens;
        let aPos = order.indexOf(a.suits[0]);
        let bPos = order.indexOf(b.suits[0]);
        console.log(`${a.name} order ${aPos}, ${b.name} order ${bPos}`)
        if(aPos != -1 && bPos != -1 && aPos != bPos) return aPos - bPos; // Lower is better
        return 0; // genuinely equal
    })
    console.log(`Favourite cards:`, eligible.map(c => c.name))
    return eligible;
}

// The card least valuable to p (e.g. where the bot puts Glory at Clean-up).
// Value and tokens are judged from p's side, but the type order is the bot's own
// tie-breaker, so it is applied in the same direction rather than reversed.
export function botLeastValuableCard(p, eligible){
    if(!eligible || eligible.length == 0) return undefined;
    let order = ['person', 'cargo', 'ship', 'ally'];
    let val = botValuer(p);
    let pos = c => { let i = order.indexOf(c.suits[0]); return i == -1 ? order.length : i; };
    return [...eligible].sort((a,b) => {
        if(val(a) != val(b)) return val(a) - val(b);
        let aTokens = countAllTokens(a);
        let bTokens = countAllTokens(b);
        if(aTokens != bTokens) return aTokens - bTokens;
        return pos(a) - pos(b);
    })[0];
}

export function namesBadlands(type){
    // Did the effect ask for the Badlands by name, rather than by a type that happens to include it?
    return [type].flat().some(t => typeof t == 'string' && t.toLowerCase().includes('badlands'));
}

export function bestShipDestinations(eligible, card, behaviour = false, allowBadlands = false){
    if(!eligible || eligible.length == 0) return false;
    
    let opp = get(state).players.find(p => !p.bot);

    let bot = get(state).players.find(p => p.bot);
    if(!opp){
        opp = get(state).players.find((p, i) => i != get(state).currentPlayer); // for BvB
        bot = get(state).players[get(state).currentPlayer];
    }

    let valBot = botValuer(bot);
    let valOpp = botValuer(opp);

    if(get(state).players.some(p => ongoingPlayer(p).includes('only_types_warp_ship_location'))){
        // Exclude any controlled locations with this particular opponent ship on
        let allRestrictions = get(state).players.flatMap(p => ongoingPlayer(p, 'only_types_warp_ship_location'));
        if(allRestrictions.some(r => !matches(card, r))){
            let excluded = [];
            outer: for(let l of eligible){
                let ships = shipsAtLocation(l, opp);
                for(let s of ships){
                    let ot = ongoingEffects(s, 'only_types_warp_ship_location');
                    if(ot.length > 0){
                        ot = ot[0];
                        if(!matches(card, ot)){
                            excluded.push(l);
                            break outer;
                        }
                    }
                }
            }
            eligible = eligible.filter(l => excluded.some(e => e.uniqueID != l.uniqueID));
        }
    }

    
    //if(!behaviour) behaviour = 'engage';
    /*if(!eligible.some(e => countAllTokens(e) == 0)) behaviour = 'engage';
    if(!eligible.some(e => countPlayerTokens(e, opp) > 0)) behaviour = 'explore';
    eligible = eligible.filter(e => {
        if(countPlayerTokens(e, bot) >= 4 && countPlayerTokens(e, opp) - countPlayerTokens(e, bot) >= 3) return false;
        return true;
    })
    if(behaviour == 'explore' && !eligible.some(e => countAllTokens(e) == 0)){
        // Fallback behaviour when it can neither explore nor engage;
        // Go to highest VP location
        eligible = eligible.sort((a,b) => {
            return botValue(b, bot) - botValue(a, bot);
        });
    }*/

    // Ships only ever go to the Badlands when an effect names it: no last-resort fallback
    if(!allowBadlands) eligible = eligible.filter(e => !isBadlands(e));
    eligible = eligible.filter(e => {
        // Feb 2026 added filter to ship warping too: it never warps to majorly overcontrolled destinations
        // Was 3, now 4! (apparently it was changed before too, so... why??)
        if(countPlayerTokens(e, bot) >= 4 && countPlayerTokens(e, bot) - countPlayerTokens(e, opp) >= 3) return false;
        return true;
    })
    if(behaviour == 'occupy'){
        let opp_locs = opp.decks.locations.filter(c => shipsAtLocation(c, bot).length == 0);
        if(opp_locs.length > 0){
            eligible = [...opp_locs].sort((a,b) => valOpp(b) - valOpp(a));
        }else{
            behaviour = 'engage';
        }
    }
    if(behaviour == 'explore'){
        /*eligible = eligible.filter(e => countAllTokens(e) == 0).sort((a,b) => {
            let aTok = botValue(a, bot);
            let bTok = botValue(b, bot);
            return bTok - aTok;
        });*/
        eligible = eligible.sort((a,b) => {
            /*if(prefer  && prefer.orderedTypes){
                for(let t of prefer.orderedTypes){
                    let aPref = matches(a, t);
                    let bPref = matches(a, t);
                    if(aPref != bPref) return bPref - aPref;
                }   
            }*/

            let aTok = countAllTokens(a);
            let bTok = countAllTokens(b);
            if(aTok != bTok) return aTok - bTok;

            let aVal = valBot(a);
            let bVal = valBot(b);
            if(aVal != bVal) return bVal - aVal;

            return 0;
        })
    }else if(behaviour == 'engage'){
        // engage
        eligible = eligible.sort((a,b) => {
            /*0if(prefer  && prefer.orderedTypes){
                for(let t of prefer.orderedTypes){
                    let aPref = matches(a, t);
                    let bPref = matches(a, t);
                    if(aPref != bPref) return bPref - aPref;
                }   
            }*/
            let aTok = countPlayerTokens(a, opp);
            let bTok = countPlayerTokens(b, opp);
            if(aTok == bTok){
                aTok = valBot(a);
                bTok = valBot(b)
            }
            return bTok - aTok;
        });
    }else{
        // Simple value equation
        eligible = eligible.sort((a,b) => {
            let aTok = valBot(a);
            let bTok = valBot(b)
            return bTok - aTok;
        });
    }
    
    
    console.log('Locations sorted by ship value for '+behaviour, eligible);
    return eligible;
}

export function botAwayOut(p, params = {}){
    let total = 0;
    for(let c of getNeutralZone()){
        total += removableAway(currentPlayer(), p, c, params);
    }
    return total;
}

export function bestAwayRemove(eligible){
    // NB it doesn't currently actually check there *are* tokens on eligible ones, presume this already filtered...
    let opp = get(state).players.find(p => !p.bot);
    let bot = get(state).players.find(p => p.bot);
    if(!bot) return eligible; // Only applies when there is a bot in play!
    if(!opp){
        opp = get(state).players.find((p, i) => i != get(state).currentPlayer); // for BvB
        bot = get(state).players[get(state).currentPlayer];
    }
    let p = bot;
    let val = botValuer(p);
    return eligible.sort((a,b) => {
        // Remove from Badlands first
        if(isBadlands(a)) return -1;
        if(isBadlands(b)) return 1;
        let initial = countPlayerTokens(a, p) - countPlayerTokens(b, p);
        if(initial == 0) initial = val(a) - val(b);
        return initial;
    })
}

export async function removeBotAway(p, num, params = {}){
    if(num > botAwayOut(p, params)) throw 'uncompleted';

    while(num > 0){
        let eligible = getNeutralZone().filter(c => removableAway(currentPlayer(), p, c, params) > 0)
        console.log('eligible places to remove from', eligible);
        //eligible = eligible.sort((a,b) => countPlayerTokens(a, p) - countPlayerTokens(b, p))[0];
        eligible = bestAwayRemove(eligible)[0];
        console.log('selected place', eligible);
        await doAction(p, 'remove_away', {obj: {num: 1}, from: eligible.uniqueID})
        console.log('selected place', eligible);
        //removeAwayTeam(p, eligible, 1);
        num--;
    }
}

export function bestAwayDestinations(eligible, type = 'away', params = {}){
    if(!eligible || eligible.length == 0) return false;
    let opp = get(state).players.find(p => !p.bot);
    let bot = get(state).players.find(p => p.bot);
    if(!bot) return eligible; // Only applies when there is a bot in play!
    
    if(!opp){
        opp = get(state).players.find((p, i) => i != get(state).currentPlayer); // for BvB
        bot = get(state).players[get(state).currentPlayer];
    }
    let valBot = botValuer(bot);
    let valOpp = botValuer(opp);
    eligible = eligible.filter(e => canBeamTo(bot, e, params)); // Preserve this action's ship exception

    eligible = eligible.filter(e => {
        // Was 3, now 4! (apparently it was changed before too, so... why??)
        if(getNeutralZone().some(cd => cd.uniqueID == e.uniqueID) && countPlayerTokens(e, bot) >= 4 && countPlayerTokens(e, bot) - countPlayerTokens(e, opp) >= 3) return false;
        return true;
    })
    // Generic destinations exclude the Badlands, even when every other location
    // is blocked. A chart effect naming it explicitly can still send there.
    if(!namesBadlands(type)) eligible = eligible.filter(e => !isBadlands(e));
    eligible = eligible.sort((a,b) => {
        let aTok = countPlayerTokens(a, bot);
        let bTok = countPlayerTokens(b, bot);
        if(aTok == bTok){
            aTok = valBot(a);
            bTok = valBot(b)
        }
        return bTok - aTok;
    });
    if(type == 'drone'){
        // Drones follow the normal away team priority (most tokens, then highest VP, ships
        // already blocking placement filtered above). Never the bot's own locations. Opponent
        // locations only appear in eligible when the effect explicitly asked for them (see the
        // away branch of resolveObjects in parse.js), so no extra preference for them here -
        // except that among the opponent's locations, ones without a bot drone come first.
        eligible = eligible.filter(c => !bot.decks.locations.some(cd => cd.uniqueID == c.uniqueID));
        let isOppLoc = c => opp.decks.locations.some(cd => cd.uniqueID == c.uniqueID);
        let oppSlots = eligible.filter(isOppLoc);
        let oppOrdered = [...oppSlots.filter(c => !drones(bot, c)), ...oppSlots.filter(c => drones(bot, c))];
        eligible = eligible.map(c => isOppLoc(c) ? oppOrdered.shift() : c); // neutral locations keep their slots
        console.log('Locations sorted by away value for BQ', eligible);
        return eligible;
    }
    console.log('Locations sorted by away value', eligible);
    return eligible;
}

export function countPlayerTokens(c, player, securing = false, excludeQ = false){
    let num = 0;
    let ind = getPlayerIndex(player);
    num += myAway(player, c); // includes drones: they are away teams
    if(c.defp && defpCard(player)) num++;
    if(c.orbiting) num += countShips(c.orbiting.filter(o => o.sourcePlayer == ind), securing, c);
    if(securing){
        // Resource counters are shared amounts on a location. They contribute only to
        // securing, never to physical-token totals or scoring. Duplicate passives do not stack.
        let counted = new Set();
        for(let rule of ongoingPlayer(player, 'resource_token_secure')){
            if(rule.yourTurnOnly && get(state).currentPlayer != ind) continue;
            if(!matches(c, rule.location + ' location') || counted.has(rule.resource)) continue;
            num += Number(c[rule.resource]) || 0;
            counted.add(rule.resource);
        }
    }
    // Need Visiting count too
    if(!excludeQ && c.visiting && player.captain == 'Q'){
        let visitCount = c.visiting.length;
        if(securing){
            let mts = ongoingPlayer(player, 'type_specific_multi_token_secure');
            let maxMult = 1;
            for(let m of mts){
                if(m.yourTurnOnly && get(state).currentPlayer != getPlayerIndex(player)) continue;
                // 'qsuit' applies to all visited locations; 'visiting_q' can be gated to a location type (e.g. neutral)
                if(m.type != 'qsuit' && m.type != 'visiting_q') continue;
                if(m.visited && !matches(c, m.visited + ' location')) continue;
                if(m.num > maxMult) maxMult = m.num;
            }
            visitCount = visitCount * maxMult;
        }
        num += visitCount;
    }
    return num;
}

// NB no 'drone' here: countSpecificTokens(c, p, 'away') already includes drones, so listing
// both would double-count every drone in the 'token' total. Ask for 'drone' by name instead.
export let allLocationTokenTypes = ['away', 'ship', 'murf', 'q', 'defp'];

export function countSpecificTokens(c, player, type){
    let num = 0;
    let tokenTypes = allLocationTokenTypes;
    let ind = getPlayerIndex(player);
    if(player == 'all'){
        for(let p of get(state).players){
            num += countSpecificTokens(c, p, type);
        }
        return num;
    }
    if(type == 'token'){
        for(let t of tokenTypes){
            num += countSpecificTokens(c, player, t);
        }
        return num;
    }
    if(type == 'away') return myAway(player, c);
    if(type == 'drone') return drones(player, c);
    if(type == 'ship') return c.orbiting ? countShips(c.orbiting.filter(o => o.sourcePlayer == ind)) : 0;
    if(type == 'murf') return (c.murf && hasMurf(player) ? 1 : 0);
    if(type == 'defp') return (c.defp && defpCard(player) ? 1: 0);
    if(type == 'q' && player.captain == 'Q') return c.visiting ? c.visiting.length : 0;
    return num;
}

export function countAllTokens(c){
    let num = 0;
    for(let t of allTokenTypes()){//cardResourceTypes()){//get(res).cardResourceTypes){
        if(c[t]) num += c[t];
    }
    for(let p of get(state).players){
        num += myAway(p, c); // includes drones
        if(c.defp && defpCard(p)) num++;
    }
    if(c.orbiting) num += countShips(c.orbiting);
    if(c.visiting) num += c.visiting.length;
    return num;
}

export async function resolveBotCard(p, c, wl = true){
    return perfMeasureAsync('bot.resolveBotCard', () => resolveBotCardInner(p, c, wl), {captain: p && p.captain});
}

async function resolveBotCardInner(p, c, wl = true){
    //resetCache(); //
    let savedCache = get(state).cache;
    resetCache();
    state.update(s => {
        s.botWorking = true;
        return s;
    })
    p = get(state).players.find(pl => pl.captain == p.captain && pl.bot);
    if(wl)  openWorkingLog();
    let chartKey = 'chart';
    if(!get(res).botCharts[p.captain][p.currentChart]) delete p.currentChart; // To reset after Khan
    let chart = get(res).botCharts[p.captain][p.currentChart || 'chart'];
    //console.log(chart, get(res).botCharts);
    let actionDone = false;
    if(p.captain == 'Borg Queen' && c.traits && c.traits.includes('sync')){
        // deploy immediately
        await doAction(p, 'deploy', {obj: c.uniqueID});
    }
    if(c.traits && c.traits.includes('surprise')){
        console.log('Matching surprise');
        try{
            if(await doBotAction(p, c, makeSurpriseEntry(c), true)){
                actionDone = true;
            }
            if(!actionDone){
                for(let entry of chart){
                    if(matches(c, entry.icon, false)){ // NB wildcard matching now turned off as per above
                        //console.log('Match found!', c, entry);
                        if(await doBotAction(p, c, entry)){
                            actionDone = true;
                            break;
                        }
                        if(get(state).endNow){
                            actionDone = true; // Not really, but the game is over so don't report a failure
                            break;
                        }
                    }
                }
            } 
        }catch(e){
            if(e != 'uncompleted') throw e;
        }
    }else{
        // Below was old way, now we *want* it to iterate through them all
        /*if(c.traits && c.traits.includes('wildcard')){
            // Do it separately so that 'continue resolution' will
            // fall through to next trait and not just iterate through them all
            if(await doBotAction(p, c, chart[0])){
                actionDone = true;
            }
        }*/
        if(!actionDone){
            for(let entry of chart){
                if(entry.exclude && matches(c, entry.exclude, false)) continue;
                if(entry.syncLevel){
                    let syncLevel = p.decks.fleet.filter(c => matches(c, 'sync', false)).length;
                    if(entry.syncLevel != syncLevel) continue;
                }
                if(entry.icon == '!any' || matches(c, entry.icon/*, false*/)){ // Previously, wildcards were turned off, but no more
                    //console.log('Match found!', c, entry);
                    if(await doBotAction(p, c, entry)){
                        actionDone = true;
                        break;
                    }
                    if(get(state).endNow){
                        actionDone = true; // Not really, but the game is over so don't report a failure
                        break;
                    }
                }
            }
        } 
    }
    if(!actionDone){
        state.update(s => {
            s.botWorking = false;
            return s;
        })
        await pause(`No action was completed for this card`);
        console.log(`Action not done for bot:`, p, c, )
        if(get(res).BvB) oneOffMessage(p, `${p.captain} action failed`, alert);
    }

    if(p.decks.play.some(card => card.uniqueID == c.uniqueID)){
        // Still there, so needs discarding/putting into play depending
        if(matches(c, 'location') && (p.captain != 'Khan' || p.currentChart != 'exile')){
            logText('Card is a [[location]], so putting into play')
            await moveTo(c, `players.locations.${getPlayerIndex(p)}`, -1);
        }
        if(matches(c, 'sync') && p.captain == 'Borg Queen'){
            logText('Card is [[sync]], so putting into play')
            await moveTo(c, `players.fleet.${getPlayerIndex(p)}`, -1);
        }
        await doActionPause(); //waitMillis(300);
    }

    state.update(s => {
        s.botWorking = false;
        if(savedCache){
            s.cache = savedCache;
        }
        return s;
    })
    
    if(wl){
        if(!get(res).BvB) await choose('Press OK to continue', ['OK'], {forceChoose: true});
        closeWorkingLog();
        await doActionPause();//await waitMillis(300);
    }
}

function makeSurpriseEntry(c){
    let entry = {
        origIcon: 'surprise',
        icon: 'surprise',
        text: 'Perform the Surprise action on the card'
    };
    let effect = getHints(c, 'surprise');
    if(effect.length == 0) throw 'uncompleted';
    effect = effect[0];
    entry.basic = effect;
    if(!entry.basic){
        logText(`Unable to complete Surprise effect because it doesn't parse`);
        throw 'uncompleted';
    }
    if(entry.basic.text){
        entry.basic.text = `${entry.text} (${entry.basic.text})`;
    }else{
        entry.basic.text = entry.text;
    }
    return entry;
}

// Bot rule: when the bot logs a card with a Surprise operation, that operation is triggered one last time.
// Only the Surprise operation: unlike resolveBotCard, never falls back to the bot chart
export async function resolveSurpriseOnLog(p, c){
    let effect = getHints(c, 'surprise');
    if(!effect || effect.length == 0 || !effect[0]) return;
    effect = effect[0];
    logText(`${c.name} is being logged by the bot, so its [[surprise]] operation is triggered one last time: <span style="background-color: white; color: black;">${effect.text}</span>`);
    let wasInBotChart = get(state).inBotChart; // The log may be happening mid-chart
    state.update(s => {
        s.inBotChart = true;
        return s;
    })
    cacheItem('cardID', c.uniqueID);
    try{
        await resolveEffects(c, effect.effects, effect.attack);
    }catch(e){
        if(e != 'uncompleted' && e != 'continue_resolution') throw e;
        logText(`[[surprise]] operation on ${c.name} could not be completed`);
    }finally{
        clearCacheItem('cardID');
        state.update(s => {
            s.inBotChart = wasInBotChart;
            return s;
        })
    }
}

function findCardForFake(p, filter, exclude = []){
    let card = allScoreableCards(p).filter(c => !exclude.some(cd => cd.uniqueID == c.uniqueID)).find(c => matches(c, filter, false));
    if(card) return card;
    card = allCards().filter(c => !exclude.some(cd => cd.uniqueID == c.uniqueID)).find(c => matches(c, filter, false) && !allScoreableCards(otherPlayer(p)).some(cd => cd.uniqueID == c.uniqueID));
    if(card) return card;
    alert(`Unable to find card that matches ${filter}!`);
    return false;
}

export async function fakeBotAction(p, e, type){
    let saved = {
        currentPlayer: get(state).currentPlayer,
        activePlayer: get(state).activePlayer
    };
    logText(`Faking action of ${e.origIcon} row (${type} type)`);

    // Load a card that matches this row if you can
    let c = findCardForFake(p, e.icon);
    
    // If it's a DO effect, put a card in as DO first if need be
    if(type == 'DO' && p.decks.duty.length == 0){
        let newDO = findCardForFake(p, 'person', [c]);
        await moveTo(newDO, `players.duty.${getPlayerIndex(p)}`);
    }

    // move into position
    await moveTo(c, `players.play.${getPlayerIndex(p)}`);

    // execute effect
    await doBotAction(p, c, e);
    
    state.update(s => {
        s.activePlayer = saved.activePlayer;
        s.currentPlayer = saved.currentPlayer;
        return s;
    })
}

export async function doBotAction(p, c, e, surprise = false){
    let entry;
    let effect = 'basic effect'
    if(e.basic){
        entry = e.basic;
    }else if(e['collective<20']){
        if(!p.hasOwnProperty('collective')){
            alert('Non-Borg Queen bot trying to execute a collective-gated effect!');
            throw 'uncompleted';
        }
        if(p.collective >= 20){
            entry = e['collective>=20'];
            effect = '[[collective]] >= 20 effect'
        }else{
            entry = e['collective<20'];
            effect = '[[collective]] < 20 effect'
        }
    }else{
        if(p.decks.duty.length > 0){
            entry = e.DO;
            effect = 'Duty Officer effect'
        }else{
            entry = e.noDO;
            effect = 'non-Duty Officer effect'
        }
    }
   
    //let done = await choose(`Action required: ${entry.text}. Successfully completed?`, ['Yes', 'No']);
    //alert(`Card ${c.name} matched icon ${e.origIcon} (${effect}): ${entry.text}`);
    logText(`Card ${c.name} matched icon ${e.origIcon} (${effect}): <span style="background-color: white; color: black;">${entry.text}</span>`);
    if(p.stats){
        let icon = e.icon;
        if(icon && e.syncLevel) icon = `${icon} ${e.syncLevel}`;
        if(!icon) throw {
            message: 'No icon in chart',
            p,
            c,
            e
        }
        if(p.currentChart) icon = `${p.currentChart}!!${icon}`;
        if(!p.stats.botActions) p.stats.botActions = {};
        if(!p.stats.botActions[icon]) p.stats.botActions[icon] = {};
        if(!p.stats.botActions[icon][effect]) p.stats.botActions[icon][effect] = 0;
        p.stats.botActions[icon][effect]++;
        if(!c.stats) c.stats = {};
        if(!c.stats.botPlay) c.stats.botPlay = 0;
        c.stats.botPlay++;
    }
    try{
        await checkForReactions(p, 'play', {card: c.uniqueID}, 'before');
        await checkForReactions(p, 'put', {card: c.uniqueID}, 'before'); // !! TODO why is this here?
        state.update(s => {
            s.inBotChart = true;
            return s;
        })
        cacheItem('cardID', c.uniqueID);
        if(surprise){
            await resolveEffects(c, entry.effects, entry.attack);
        }else{
            await autoCardActions(entry, getAllPlayEffects(entry), true, c);
        }
        clearCacheItem('cardID', c.uniqueID);
        state.update(s => {
            s.inBotChart = false;
            return s;
        })
        await checkForReactions(p, 'play', {card: c.uniqueID}, 'after');

        if(p.captain == 'Pike'){
            // Bump up for relevant skills
            let max = {
                type: '',
                num: 0
            }
            for(let t of ['res', 'inf', 'mil']){
                let count = matches(c, `${t}-skill`); // Wild counted by default so that's fine
                if(count > max.num){ // So will only override if genuinely higher
                    max.num = count;
                    max.type = t;
                }
            }
            if(max.num > 0){
                let track =  get(res).trackTypes.find(t => t.startsWith(max.type));
                logText(`Pike special bot effect: gaining ${max.num} [[${track}]] for skills on card`);
                await doAction(p, 'gain_track', {track, amount: max.num, auto: true})
            }
        }
    }catch(e){
        if(e == 'continue_resolution'){
            state.update(s => {
                s.continueResolution = true;
                return s;
            })

        }else if(e == 'cancelled'){
            await choose(`Bot action was cancelled for some reason: report this as a bug`, ['OK'], {forceChoose: true})
        }else{
            throw e;
        }
    }

    if(get(state).continueResolution){
        state.update(s => {
            delete s.continueResolution;
            return s;
        })
        return false;
    }
    
    return true; // !! TODO check board state change
}
